import { render, staticRenderFns } from "./all-project-student.pug?vue&type=template&id=24c8e04c&lang=pug&"
import script from "./all-project-student.ts?vue&type=script&lang=ts&"
export * from "./all-project-student.ts?vue&type=script&lang=ts&"
import style0 from "./all-project-student.styl?vue&type=style&index=0&lang=stylus&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports